import React from 'react';
import heroImage from '../../../../assets/images/about/hero/hero.jpg';
import './Hero.css';

const stats = [
  { value: '4', label: 'Locations' },
  { value: '15+', label: 'Employees' },
  { value: '500+', label: 'Clients' },
];

const Hero = () => {
  return (
    <section className="about-hero">
      <div className="about-hero__inner">
        <div className="about-hero__copy">
          <p className="about-hero__eyebrow">About Us</p>
          <h1 className="about-hero__title">
            Trusted Advisors for Complex Financial Landscapes.
          </h1>
          <p className="about-hero__text">
            VBS Financial Securities is a financial consulting and asset
            management firm committed to excellence, innovation, and long-term
            client success. We help organizations and private clients navigate
            complexity with clarity and discipline.
          </p>
        </div>

        <div className="about-hero__banner">
          <img
            className="about-hero__image"
            src={heroImage}
            alt=""
            aria-hidden="true"
          />

          <div className="about-hero__stats">
            {stats.map(({ value, label }) => (
              <article key={label} className="about-hero__stat">
                <p className="about-hero__stat-value">{value}</p>
                <p className="about-hero__stat-label">{label}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
